export enum AUTHORIZATION_TYPE_ENUM {
  REJECTED = 0,
  MESSAGE = 1,
  PHONE = 2,
  PERSONALLY = 3,
  EMAIL = 4,
  WEB = 5,
  WAITING = 6,
  ADDITIONAL_AUTHORIZED = 7,
  ADDITIONAL_REJECTED = 8,
}

export const authorizationTypes = {
  rejected: { id: AUTHORIZATION_TYPE_ENUM.REJECTED, label: 'ELEMENT.AUTHORIZATION_TYPE.REJECTED', name: 'rejected' },
  message: { id: AUTHORIZATION_TYPE_ENUM.MESSAGE, label: 'ELEMENT.AUTHORIZATION_TYPE.MESSAGE', name: 'message' },
  phone: { id: AUTHORIZATION_TYPE_ENUM.PHONE, label: 'ELEMENT.AUTHORIZATION_TYPE.PHONE', name: 'phone' },
  personally: { id: AUTHORIZATION_TYPE_ENUM.PERSONALLY, label: 'ELEMENT.AUTHORIZATION_TYPE.PERSONALLY', name: 'personally' },
  email: { id: AUTHORIZATION_TYPE_ENUM.EMAIL, label: 'ELEMENT.AUTHORIZATION_TYPE.EMAIL', name: 'email' },
  web: { id: AUTHORIZATION_TYPE_ENUM.WEB, label: 'ELEMENT.AUTHORIZATION_TYPE.WEB', name: 'web' },
  waiting: { id: AUTHORIZATION_TYPE_ENUM.WAITING, label: 'ELEMENT.AUTHORIZATION_TYPE.WAITING', name: 'waiting' },
  additional_authorized: { id: AUTHORIZATION_TYPE_ENUM.ADDITIONAL_AUTHORIZED, label: 'ELEMENT.AUTHORIZATION_TYPE.ADDITIONAL_AUTHORIZED', name: 'additional_authorized' },
  additional_rejected: { id: AUTHORIZATION_TYPE_ENUM.ADDITIONAL_REJECTED, label: 'ELEMENT.AUTHORIZATION_TYPE.ADDITIONAL_REJECTED', name: 'additional_rejected' },
}
